<template>
	<a-row class="reportTableBox">
		<a-col :span='24' class="titleBox">
			<a-col :span='4' class="left">筛选结果</a-col>
			<a-col :span='20' class="right">
				<a-button :disabled="loading" type="primary" class="btn" @click="onDownload()">导出</a-button>
			</a-col>
		</a-col>
		<a-col :span='24'>
			<a-table @change="handleTableChange" :columns="columns" :dataSource="dataList" :loading="loading" :pagination="false" bordered></a-table>
			<a-pagination v-model="pageIndex" :page-size="pageSize" :page-size-options="pageSizeOptions" show-size-changer :total="total" @change="onShowIndexChange" @showSizeChange="onShowSizeChange" class="paginationBox" />
		</a-col>
		<report-chart ref='reportChart' :dataList="dataList" :loading="loading"></report-chart>
	</a-row>
</template>

<script>
	import ExportTool from "@/core/exportExcel/exportTool.js";
	import { filterList, columns } from './columns';
	import reportChart from './reportChart.vue';
	const orderMap = {
		ascend: "ASC",
		descend: "DESC"
	}
	export default {
		components: {
			reportChart
		},
		computed: {
			// 丰富列信息。搜索、排序、重置状态都需要动态列信息，所以没有将列信息设置为静态的json
			columns() {
				const columnList = columns.map(header => {
					let dataIndex = filterList.find(e => e == header.dataIndex);
					if(dataIndex) {
						// clearAll必须设置以下这两个属性，否则无效 【详情查看ant-design官网--#可控的筛选和排序】
						header.filteredValue = this.filteredInfo?.[dataIndex] || []; // 官网给出的默认值是null，然而亲测报错，filteredValue数组类型，所以这里默认值给空数组
						header.sortOrder = this.sortedInfo?.columnKey === dataIndex && this.sortedInfo?.order;
					}
					return header;
				})
				return columnList;
			},
			// 搜索项
			filters() {
				return this.$store.state.reportSearchFilter;
			}
		},
		data() {
			return {
				filteredInfo: null, // 所有搜索列的集合--用于集中搜索和重置
				sortedInfo: null, // 所有排序的集合--用于集中搜索和重置
				dataList: [],
				loading: false,
				pageSizeOptions: ['10', '20', '30'],
				total: 0,
				pageIndex: 1,
				pageSize: 10
			}
		},
		mounted() {
			this.loadData()
			this.$root.$bus.$on("ResetReport", () => this.clearAll())
			this.$root.$bus.$on("QueryReport", () => this.loadData());
		},
		methods: {
			// 重置列表搜索、排序等
			clearAll() {
				this.filteredInfo = null;
				this.sortedInfo = null;
				this.loadData()
			},
			// 表头操作的回调
			handleTableChange(pagination, filters, sorter) {
				this.filteredInfo = filters;
				this.sortedInfo = sorter;
				this.loadData()
            },
            getParams() {
                return {
                    tenant: "msd",
					reportKey: "Report_By_User",
					pageIndex: this.pageIndex,
					pageSize: this.pageSize,
					filters: this.filters,
					orderBy: this.sortedInfo?.columnKey ? `ORDER BY ${this.sortedInfo.columnKey} ${orderMap[this.sortedInfo.order]}` : ""
                }
            },
			loadData() {
				this.loading = true;
				let params = this.getParams();
				this.$ajax.QueryReport(params).then(response => {
					this.loading = false;
					this.dataList = response.content.rows;
					this.dataList.map((ele, index) => {
						ele.key = index.toString()
					})
					this.total = response.content.total;
				})
			},
			// 导出
			onDownload() {
				const {
					barCharts = [],
					lineCharts = []
				} = this.$refs.reportChart
				this.$iLoading.render({
					message: "正在下载，请耐心等待..."
				})
				let params = this.getParams();
				params.series = [{
					title: "订车人花费排序",
					barCharts: barCharts.filter(e => e.checked).map(ele => {
						return {
							column: ele.column,
							axisTitle: ele.axisTitle,
							position: ele.position
						}
					}),
					lineCharts: lineCharts.filter(e => e.checked).map(ele => {
						return {
							column: ele.column,
							axisTitle: ele.axisTitle,
							position: ele.position
						}
					})
				}]
				this.$ajax.DownloadReport(params).then(response => {
					this.$iLoading.close()
					this.$message.success("导出成功")
					new ExportTool({
						fileUrl: response.content,
						fileName: "会议统计分析",
						fileFormat: ".xlsx",
						alert: this.$message.info
					}).getUrl()
				})
			},
			// 分页
			onShowSizeChange(pageIndex, pageSize) {
				this.pageSize = pageSize;
				this.pageIndex = pageIndex;
				this.loadData()
			},
			// 分页
			onShowIndexChange(pageIndex, pageSize) {
				this.pageSize = pageSize;
				this.pageIndex = pageIndex;
				this.loadData()
			}
		}
	}
</script>

<style scoped="scoped" lang="scss">
	.reportTableBox {
		margin-top: 16px;
		border: 1px solid #bfcbd9;
		padding: 16px;
		border-radius: 5px;
		.titleBox {
			padding-bottom: 10px;
			border-bottom: 1px dashed #bfcbd9;
			margin-bottom: 15px;
			.right {
				text-align: right;
				.btn {
					width: 120px;
					margin-left: 16px;
				}
			}
		}
		.paginationBox {
			text-align: right;
			padding: 16px 0px;
		}
		.highlight {
			background-color: rgb(255, 192, 105);
			padding: 0px;
		}
	}
</style>